import DioramaCamera from "../../../lib/services/scene/diorama_camera";
import DioramaCameraControl from "../../../lib/services/scene/diorama_camera_control";
import Puppy from "./puppy";

export type FollowPhase = "outbound" | "returning" | "idle";

export default abstract class FollowCamera {
  protected camera: DioramaCamera;
  protected cameraControl: DioramaCameraControl;
  protected puppy: Puppy;

  protected linger = 0.0;
  protected restoring = false;
  protected lastPhase: FollowPhase = "idle";

  constructor(
    camera: DioramaCamera,
    cameraControl: DioramaCameraControl,
    puppy: Puppy
  ) {
    this.camera = camera;
    this.cameraControl = cameraControl;
    this.puppy = puppy;
  }

  tick(deltaTime: number): void {
    const phase = this.getPhase();

    if (this.wasReturningAndStopped(this.lastPhase, phase)) {
      this.linger = this.getLingerTime();
    }

    if (this.linger > 0.0) {
      this.linger -= deltaTime;
      if (this.linger < 0.0) this.linger = 0.0;
    }

    const followingNow = this.isFollowActive(phase) || this.linger > 0.0;

   /* console.log("follow tick", {
  phase,
  lastPhase: this.lastPhase,
  linger: this.linger,
  followingNow,
  restoring: this.restoring,
  controlEnabled: this.cameraControl.is_enabled(),
});*/

    if (followingNow) {
      this.restoring = false;

      if (this.cameraControl.is_enabled()) {
        this.cameraControl.set_enabled(false);
      }

      this.updateFollowCamera(phase, deltaTime);
    } else {
      if (!this.restoring && !this.cameraControl.is_enabled()) {
        this.restoring = true;
      }

      if (this.restoring) {
        this.updateCameraRestore(deltaTime);
      } else {
        this.cameraControl.tick(deltaTime);
      }
    }

    this.lastPhase = phase;
  }

  protected wasReturningAndStopped(lastPhase: FollowPhase, phase: FollowPhase): boolean {
    return lastPhase === "returning" && phase !== "returning";
  }

  protected isFollowActive(phase: FollowPhase): boolean {
    return phase === "outbound" || phase === "returning";
  }

  protected getLingerTime(): number {
    return 0.75;
  }
  public is_busy(): boolean {
  return this.getPhase() !== "idle" || this.linger > 0.0 || this.restoring;
}

 protected updateCameraRestore(deltaTime: number): void {
  const targetX = 0.0;
  const targetY = 0.5;
  const targetZ = 2.8;
  const targetYaw = Math.PI * 0.03;
  const targetPitch = 0.08;
  const targetDistance = 8.0;
  const targetFov = Math.PI / 8.5;

  const blend = Math.min(1.0, deltaTime * 3.5);

  const nextX = this.camera.target[0] + (targetX - this.camera.target[0]) * blend;
  const nextY = this.camera.target[1] + (targetY - this.camera.target[1]) * blend;
  const nextZ = this.camera.target[2] + (targetZ - this.camera.target[2]) * blend;

  const nextYaw = this.camera.yaw + (targetYaw - this.camera.yaw) * blend;
  const nextPitch = this.camera.pitch + (targetPitch - this.camera.pitch) * blend;
  const nextDistance = this.camera.distance + (targetDistance - this.camera.distance) * blend;
  const nextFov = this.camera.fov_y + (targetFov - this.camera.fov_y) * blend;

  this.camera.set_style_angle(nextYaw, nextPitch);
  this.camera.set_fov_y(nextFov);
  this.camera.set_distance_bounds(1.0, 30.0);
  this.camera.set_distance(nextDistance);
  this.camera.set_target(nextX, nextY, nextZ);

  const done =
    Math.abs(nextX - targetX) < 0.01 &&
    Math.abs(nextY - targetY) < 0.01 &&
    Math.abs(nextZ - targetZ) < 0.01 &&
    Math.abs(nextYaw - targetYaw) < 0.001 &&
    Math.abs(nextPitch - targetPitch) < 0.001 &&
    Math.abs(nextDistance - targetDistance) < 0.01 &&
    Math.abs(nextFov - targetFov) < 0.001;

  if (done) {
    this.camera.set_target(targetX, targetY, targetZ);
    this.camera.set_style_angle(targetYaw, targetPitch);
    this.camera.set_fov_y(targetFov);
    this.camera.set_distance_bounds(1.0, 30.0);
    this.camera.set_distance(targetDistance);

    this.cameraControl.set_pan_bounds(-4.0, 4.0);
    this.cameraControl.set_sensitivity(0.008, 0.010);
    this.cameraControl.set_smoothing(0.25);
    this.cameraControl.snap_to(0.0);
    this.cameraControl.set_enabled(true);

    this.restoring = false;
  }

  }

  protected abstract getPhase(): FollowPhase;
  protected abstract updateFollowCamera(phase: FollowPhase, deltaTime: number): void;
}